import { render, staticRenderFns } from "./ConferenceCountdown.vue?vue&type=template&id=51d5a2c2&scoped=true&"
import script from "./ConferenceCountdown.vue?vue&type=script&lang=js&"
export * from "./ConferenceCountdown.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceCountdown.vue?vue&type=style&index=0&id=51d5a2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5a2c2",
  null
  
)

export default component.exports